import { normalizeSort } from '../utils'
import DealerService from '../services/DealerService'

const state = () => ({
  list: [],
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['name'],
    sortDesc: [false]
  }
})

const getters = {
  DEALERS: state => {
    return state.list
  },
  DEALERS_PAG: state => {
    return state.pagination
  }
}

const mutations = {
  SET_DEALERS: (state, payload) => {
    state.list = payload
  },
  SET_DEALERS_PAG: (state, payload) => {
    state.pagination = payload
  },
  DELETE_DEALER: (state, payload) => {
    payload.status = 0
    payload.status_description = 'Deshabilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ENABLE_DEALER: (state, payload) => {
    payload.status = 1
    payload.status_description = 'Habilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ADD_DEALER: (state, payload) => {
    state.list.push(payload)
  },
  UPDATE_DEALER: (state, payload) => {
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  }
}

const actions = {
  LOAD_DEALERS: async ({ commit, state }, filter) => {
    try {
      let pagination = {
        'page': state.pagination.page,
        'per-page': state.pagination.itemsPerPage,
        'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc)
      }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }

      let { data, status } = await DealerService.get({ ...currentFilter, ...pagination })
      if (status === 200) {
        commit('SET_DEALERS', data.data)
        return data._meta.totalCount
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de usuarios')
      console.error(error)
    }
  },
  VIEW_DEALER: async (obj, params) => {
    try {
      let { data, status } = await DealerService.view(params)
      if (status === 200) {
        return data.data
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar obtener los detalles del usuario')
    }
  },
  ADD_DEALER: async ({ commit }, payload) => {
    try {
      let { data, status } = await DealerService.post(payload)
      if (status === 201) {
        commit('ADD_DEALER', data)
        window.app.$toast.success('El usuario ha sido registrado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  UPDATE_DEALER: async ({ commit }, payload) => {
    try {
      let { data, status } = await DealerService.put(payload)
      if (status === 200 || status === 201) {
        commit('UPDATE_DEALER', data)
        window.app.$toast.success('El usuario ha sido actualizado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  DELETE_DEALER: async ({ commit }, payload) => {
    try {
      let { status } = await DealerService.delete(payload)
      if (status === 204) {
        commit('DELETE_DEALER', payload)
        window.app.$toast.success('El usuario ha sido deshabilitado satisfactoriamente')
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar deshabilitar el usuario')
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
